import { Api } from '../lib'

const TYPE = {
  receive_main_menu: 'RECEIVE_MAIN_MENU',
  receive_footer_menu: 'RECEIVE_FOOTER_MENU'
}

const api = new Api()

const fetchMenu = (menu_id, type) => ( dispatch, getState ) => api
  .get('menus', {
    keys: {menu_id: menu_id}
  })

  .then( menu => {
    if(type === 'main') {
      dispatch({ type: TYPE.receive_main_menu, payload: menu.data })
    } else {
      dispatch({ type: TYPE.receive_footer_menu, payload: menu.data })
    }
  })

export default {
  TYPE,
  fetchMenu
}
